import React from 'react';
import './Chapters.scss';

function Chapter1() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph firstPg">
        <span style={{ fontWeight: 600 }}>It’s an age-old question:</span> If you were stranded on a
        remote island, what would you bring?
      </p>
      <p className="chapter__paragraph">
        For some of us, the answer might be a favorite book, or—for the more practically minded—a
        water-filtration system or signal flares. For the conservationists working to save
        endangered species and the fragile ecosystem on Robinson Crusoe Island, arguably the most
        remote island on Earth, it turns out that the answer is Lenovo’s{' '}
        <a
          href="https://www.lenovo.com/us/en/servers-storage/solutions/edge-computing/"
          target="_blank"
          rel="sponsored"
          style={{ color: '#7A126B', textDecoration: 'none', fontWeight: 500 }}
        >
          edge computing solutions{' '}
        </a>
        with AI capabilities.
      </p>
    </section>
  );
}

export default Chapter1;
